
import { ReviewUI } from "@/types/supabase";

/**
 * A hook to calculate statistics from review data
 * @param reviews Array of reviews to analyze
 * @returns Object containing calculated statistics
 */
export function useReviewStats(reviews: ReviewUI[] | undefined) {
  // If admin, only count public reviews for stats
  const publicReviews = reviews?.filter(review => review.isPublic !== false) || [];
  
  if (!publicReviews || publicReviews.length === 0) {
    return { 
      averageRating: 0, 
      totalReviews: 0,
      isTopRated: false 
    };
  }

  const totalReviews = publicReviews.length;
  const totalRating = publicReviews.reduce((sum, review) => sum + review.rating, 0);
  const averageRating = totalRating / totalReviews;
  
  // A provider is top rated if it has an average rating of > 4.5 and at least one review
  const isTopRated = averageRating > 4.5 && totalReviews > 0;

  return {
    averageRating,
    totalReviews,
    isTopRated
  };
}
